import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {SiteService} from '../../../services/site/site.service';
import {
  Dispatch,
  DispatchStats,
  Program,
  ProgramSite,
  Site, SiteDispatchStats, UIDispatch,
} from '../../../domain/cloud-topology';
import {takeUntil} from 'rxjs/operators';
import {forkJoin, Observable, Subject} from 'rxjs';
import {BaseRefreshComponent} from '../base-refresh/base-refresh.component';
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {DispatchService} from "../../../services/vpp/dispatch.service";
import {
  ACTUAL_POWER_CRITICAL,
  ACTUAL_POWER_UNDERPERFORMING,
  BAD_DER_STATE,
  BAD_SITE_STATE,
  BULK_CHARGE,
  BULK_GENERATE,
  BULKCHARGE,
  BULKGENERATE,
  CHARGING_NOT_GENERATING,
  DEFAULT_UNIT,
  DISPATCH_ACTIVE,
  DISPATCH_ERROR,
  DISPATCH_PENDING,
  GENERATING_NOT_CHARGING,
  INADEQUATE_ENERGY_FOR_MANEUVER_DURATION,
  MANEUVER_NOT_FOUND,
  NOT_AUTOMATIC_GENERATION,
  NOT_AUTOMATIC_OPTIMIZATION,
  PLANNED_POWER_CRITICAL,
  PLANNED_POWER_UNDERPERFORMING,
  SITE_STATUS_ACTIVE,
  SITE_STATUS_CRITICAL,
  SITE_STATUS_NON_ACTIVE,
  SITE_STATUS_NORMAL,
  SITE_STATUS_PERFORMING,
  SITE_STATUS_UNDER_PERFORMING,
  UNKNOWN_ACTIVITY_STATUS,
  UNKNOWN_SITE_DISPATCH_STATUS
} from "../../../domain/constants";
import moment from "moment-timezone"
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
    selector: 'app-account-status',
    templateUrl: './account-status.component.html',
    styleUrls: ['./account-status.component.css'],
    standalone: false
})
export class AccountStatusComponent extends BaseRefreshComponent implements OnInit, OnDestroy, OnChanges {

  @Input() program: Program;
  @Input() programSites: ProgramSite[];
  @Input() timezone: string;
  @Input() dispatchHourTimeWindow: number;
  @Input() selectedDispatch;
  @Input() refreshEnabled: boolean = true;
  programDispatches: Dispatch[];
  dispatchStatus: DispatchStats;
  subject$: Subject<void>;
  sites: Site[];
  loading: boolean;
  page = 1;
  pageSize = 5;
  private error = '#FC4B88';
  private pending = '#FECC32';
  private other = '#717171';
  private active = '#55BD5A';
  displayedColumns: string[] = ['status', 'site', 'requestedPower', 'plannedOutput','maxPower','currentPower','stateOfCharge'];
  dataSource: MatTableDataSource<Site>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  constructor(private siteService: SiteService,
              private dispatchService: DispatchService,
              private snackBar: MatSnackBar) {
    super();
    this.dataSource = new MatTableDataSource<Site>();

  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    let repullData = false;
    this.subject$ = new Subject<void>();
    if (changes['program'] && changes['program']['currentValue'] !== undefined) {
      this.program = changes['program']['currentValue'];
      repullData = true;
    }

    if (changes['programSites'] && changes['programSites']['currentValue'] !== undefined) {
      this.programSites = changes['programSites']['currentValue'];
      repullData = true;
    }

    if (changes['timezone'] && changes['timezone']['currentValue'] !== undefined) {
      this.timezone = changes['timezone']['currentValue'];
      repullData = true;
    }

    if (changes['selectedDispatch'] && changes['selectedDispatch']['currentValue'] !== undefined)  {
      this.selectedDispatch = changes['selectedDispatch']['currentValue'];
      repullData = true;
    }

    if (this.refreshEnabled !== undefined && changes['refreshEnabled'] && changes['refreshEnabled']['currentValue'] !== undefined) {
      this.refreshEnabled = changes['refreshEnabled']['currentValue'];
      repullData = true;
    }

    if(repullData) {
      this.setData();
    }
  }


  ngOnDestroy(): void {
    super.ngOnDestroy();

    this.subject$.next();
    this.subject$.complete();
  }

  setData() {
    if (this.program) {
      this.loading = true;
      this.sites = [];
      let subscriptions: Observable<unknown>[] = [];

      subscriptions.push(this.dispatchService.getProgramDispatches(this.program, this.timezone, [DISPATCH_PENDING, DISPATCH_ACTIVE, DISPATCH_ERROR]));
      if (this.selectedDispatch) {
        subscriptions.push(this.dispatchService.getDispatchStatus(this.selectedDispatch));
      }
      for (const programSite of this.programSites) {
        if (programSite) {
          subscriptions.push(this.siteService.getSite(programSite.id, false));
        }
      }
      forkJoin(subscriptions).pipe(takeUntil(this.subject$)).subscribe(results => {
        this.loading = false;
        if (results[0]) {
          const tempResult = <Dispatch[]>results[0];
          const currDate = moment().tz(this.timezone);
          this.programDispatches = tempResult.filter((dispatch, i) => {
            const startTime = moment(dispatch.startTimeUtc);
            if (startTime.diff(currDate, 'hours') <= this.dispatchHourTimeWindow) {
              return dispatch;
            }
          });

          if (this.programDispatches.length && !this.selectedDispatch) {
            let closestDispatch;
            this.programDispatches.forEach((dispatch) => {
              let diff = moment(dispatch.startTimeUtc).diff(currDate, 'seconds');
              if (diff > 0) {
                if (closestDispatch) {
                  if (moment(closestDispatch.startTimeUtc).diff(currDate, 'seconds') < 0) {
                    closestDispatch = dispatch;
                  }
                }
                else {
                  closestDispatch = dispatch;
                }
              }
            });

            if (closestDispatch) {
              this.selectedDispatch = closestDispatch;
              this.dispatchService.getDispatchStatus(closestDispatch).subscribe(statsData => {
                this.dispatchStatus = statsData;
                console.log(this.dispatchStatus)
              }, (error) => {
                console.error(error);
              });
            }
          }
        }

        if (results[1]) {
          this.dispatchStatus = <DispatchStats>results[1];
        }

        //Loop through remaining subscriptions as they are sites that need to be populated with data.
        if (results) {
          for (let i = 1; i < results.length; i++) {
            const site = <Site>results[i];
            if (site.id) {
              this.sites.push(site);
              if (this.sites.indexOf(site) == this.programSites.length - 1) {
                this.loading = false;
                this.dataSource = new MatTableDataSource<Site>(this.sites);
                setTimeout(() => {
                  this.dataSource.paginator = this.paginator;
                  this.dataSource.sort = this.sort;
                });
              }
            }
          }
        } else {
          this.loading = false;
          this.snackBar.open(`Error receiving site data from vpp monitor service.`, "Close",{
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "bottom"
          });
        }
      }, (err) => {
        console.log(err);
        this.loading = false;
        this.snackBar.open(`Error receiving data from vpp monitor service.`, "Close",{
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "bottom"
        });
      });
    }
  }

  aggregatedStoreStatus(element): string { // Code from Legacy UI //
    if (this.dispatchStatus.siteDispatchStatuses){
      for (const siteDispatchStatus of this.dispatchStatus.siteDispatchStatuses) {
        if (element.id == siteDispatchStatus.siteId) {
          return siteDispatchStatus.siteSystemState;
        }
      }
    }

    return '';
  }

  getSiteStat(site: Site, statKey) {
    if(this.dispatchStatus.siteDispatchStatuses) {
      for (const siteStats of this.dispatchStatus.siteDispatchStatuses) {
        if (site.id == siteStats.siteId) {
          if (siteStats[statKey] !== null) {
            if (statKey == 'stateOfCharge') {
              return UIDispatch.cleanNumericOutput(siteStats[statKey].value) +'%';
            } else {
              return UIDispatch.cleanNumericOutput(siteStats[statKey].value) +'kW';
            }
          }
        }
      }
    }
    return 'N/A';
  }

  getPlannedPower(site: Site): string {
    let realTimePower = 0;
    let defaultUnit = DEFAULT_UNIT;
    if (this.dispatchStatus.siteDispatchStatuses) {
      for (const siteStats of this.dispatchStatus.siteDispatchStatuses) {
        if (site.id == siteStats.siteId) {
          realTimePower += siteStats.requestedPower.value;
          defaultUnit = siteStats.requestedPower.defaultUnit;
        }
      }
      return `${realTimePower.toFixed(1)} ${defaultUnit}`;
    } else {
      return 'N/A'
    }

  }

  getPlannedOutput(site: Site): string {
    let plannedOutput = 0;
    let defaultUnit = DEFAULT_UNIT;
    if (site && this.selectedDispatch && this.dispatchStatus && this.dispatchStatus.siteDispatchStatuses) {
      for (const siteDispatchStats of this.dispatchStatus.siteDispatchStatuses) {
        if (site.id == siteDispatchStats.siteId) {
          plannedOutput += siteDispatchStats.plannedPower.value
          defaultUnit = siteDispatchStats.plannedPower.defaultUnit;
        }
      }
      return `${plannedOutput.toFixed(1)} ${defaultUnit}`
    } else {
      return 'N/A';
    }

  }



  aggregatedPowerCapacity(): number {
    let aggregatedPower = 0;

    for (const site of this.sites) {
      if (site.state) {
        aggregatedPower += site.availablePower ? site.availablePower : 0;
      }
    }

    return aggregatedPower;
  }

  setDiagnosticsLink(site: Site): string {
    const host = location.host.replace('config', 'cloud');
    const route = '/#/app/home/sites/'

    return `${host}${route}${site.id}`;
  }

  getMaxDispatchPower(site: Site): string {
    let maxDispatchPower = 0;
    let defaultUnit = DEFAULT_UNIT;
    if (site && this.selectedDispatch && this.dispatchStatus.siteDispatchStatuses) {
      for (const siteDispatchStats of this.dispatchStatus.siteDispatchStatuses) {
        if (site.id == siteDispatchStats.siteId) {
          maxDispatchPower += siteDispatchStats.maxDispatchPower.value;
          defaultUnit = siteDispatchStats.maxDispatchPower.defaultUnit;
        }
      }
      return `${maxDispatchPower.toFixed(1)} ${defaultUnit}`;
    }

    return 'N/A';
  }

  getSiteStatusColor(element) {
    if (this.dispatchStatus.siteDispatchStatuses) {
      for (const siteDispatchStatus of this.dispatchStatus.siteDispatchStatuses) {
        if (siteDispatchStatus && element.id == siteDispatchStatus.siteId) {
          const siteStatus = siteDispatchStatus.statusDetail;
          if (siteStatus == SITE_STATUS_CRITICAL || siteStatus == BAD_SITE_STATE || siteStatus == BAD_DER_STATE ||
            siteStatus == CHARGING_NOT_GENERATING || siteStatus == GENERATING_NOT_CHARGING || siteStatus == PLANNED_POWER_CRITICAL
            || siteStatus == ACTUAL_POWER_CRITICAL || siteStatus == NOT_AUTOMATIC_GENERATION) {
            return this.error;
          }

          if (siteStatus == SITE_STATUS_NON_ACTIVE || siteStatus == UNKNOWN_ACTIVITY_STATUS || siteStatus == UNKNOWN_SITE_DISPATCH_STATUS) {
            return this.other;
          }

          if (siteStatus == SITE_STATUS_PERFORMING || siteStatus == SITE_STATUS_ACTIVE || siteStatus == SITE_STATUS_NORMAL) {
            return this.active;
          }

          if (siteStatus == SITE_STATUS_NORMAL || siteStatus == SITE_STATUS_UNDER_PERFORMING
            || siteStatus == INADEQUATE_ENERGY_FOR_MANEUVER_DURATION || siteStatus == BULK_CHARGE
            || siteStatus == BULK_GENERATE || siteStatus == ACTUAL_POWER_UNDERPERFORMING
            || siteStatus == SITE_STATUS_UNDER_PERFORMING
            || siteStatus == PLANNED_POWER_UNDERPERFORMING
            || siteDispatchStatus.siteSystemState == BULKCHARGE || siteDispatchStatus.siteSystemState == BULKGENERATE) {
            return this.pending;
          }
        } else {
          return this.error
        }
      }
    }

    if (!this.dispatchStatus) {
      return this.error
    } else {
      return this.other;
    }
  }


  getSiteStatusText(element): string {
    if (this.dispatchStatus.siteDispatchStatuses) {
      for (const siteDispatchStatus of this.dispatchStatus.siteDispatchStatuses) {
        if (element.id == siteDispatchStatus.siteId) {
          return this.getSiteStatus(element);
        }
      }
    }

    return SITE_STATUS_NON_ACTIVE;
  }

  getSiteStatusDetailAlert(element, keys: string[]) {
    if (this.dispatchStatus.siteDispatchStatuses) {
      for (const siteDispatchStatus of this.dispatchStatus.siteDispatchStatuses) {
        if (siteDispatchStatus && element.id == siteDispatchStatus.siteId) {
          for (const key of keys) {
              if (siteDispatchStatus.statusDetail == key || this.getStatusAndGenerationState(siteDispatchStatus)) {
                return true;
              }
            }
          }
        }
      }
    return false;
  }

  getSiteStatus(element): string {
    for (const siteDispatchStatus of this.dispatchStatus.siteDispatchStatuses) {
      if (element.id == siteDispatchStatus.siteId) {
        return siteDispatchStatus.derStates.join(', ');
      }
    }

    return 'N/A';
  }

  getTooltipDesc(element): string {
    // TODO: This presents some tech-debt for translations.
    let siteDispatchStats = this.getSiteDispatchStats(element);
    let desc = '';
    if (this.dispatchStatus) {
      let active = (this.dispatchStatus.status === "ACTIVE");
      let pending = (this.dispatchStatus.status === "PENDING");
      if (siteDispatchStats) {
        switch (siteDispatchStats.statusDetail) {
          case SITE_STATUS_NORMAL:
            if (active) desc = 'Actual Power is >= 95% of Requested Power';
            if (pending) desc = 'Planned Power is >= 95% of Requested Power';
            break;
          case ACTUAL_POWER_CRITICAL:
            desc = 'Maneuver requirements not being fulfilled. Currently generating/charging < 90% of Requested Power';
            break;
          case ACTUAL_POWER_UNDERPERFORMING:
            desc = '90% Requested Power <= Actual Power <= 95% Requested Power';
            break;
          case BAD_DER_STATE:
            desc = 'DER in error state and not following maneuver instructions';
            break;
          case BAD_SITE_STATE:
            desc = 'Site not in AutomaticOptimization and will not fulfill maneuver requirements';
            break;
          case CHARGING_NOT_GENERATING:
            if (active) desc = 'Dispatch requests generating but site is currently charging';
            if (pending) desc = 'Dispatch requests generating but site is planning on charging';
            break;
          case GENERATING_NOT_CHARGING:
            if (active) desc = 'Dispatch requests charging but site is currently generating';
            if (pending) desc = 'Dispatch requests charging but site is planning on generating';
            break;
          case INADEQUATE_ENERGY_FOR_MANEUVER_DURATION:
            if (active) desc = 'Currently meeting power requirement but SOC is low so site will run out of energy before the maneuver ends';
            if (pending) desc = 'Planning on meeting power requirement but SOC is low so site will run out of energy before the maneuver ends';
            break;
          case MANEUVER_NOT_FOUND:
            desc = 'Could not find maneuver';
            break;
          case NOT_AUTOMATIC_OPTIMIZATION:
            if (siteDispatchStats.siteSystemState == BULKCHARGE) {
              desc = 'Site in BULK_CHARGE instead of AutomaticOptimization';
            } else if (siteDispatchStats.siteSystemState == BULKGENERATE) {
              desc = 'Site in BULK_GENERATE instead of AutomaticOptimization';
            } else {
              desc = 'Site not currently in AutomaticOptimization. AutomaticOptimization required for VPP monitoring';
            }
            break;
          case PLANNED_POWER_CRITICAL:
            desc = "Maneuver requirements not being fulfilled. Planning on generating/charging < 90% of Requested Power";
            break;
          case PLANNED_POWER_UNDERPERFORMING:
            desc = '90% Requested Power <= Planned Power <= 95% Requested Power';
            break;
          case SITE_STATUS_UNDER_PERFORMING:
            if (siteDispatchStats.siteSystemState == BULKCHARGE) {
              desc = 'Site in BULK_CHARGE instead of AutomaticOptimization';
            } else if (siteDispatchStats.siteSystemState == BULKGENERATE) {
              desc = 'Site in BULK_GENERATE instead of AutomaticOptimization';
            } else {
              desc = 'Site not currently in AutomaticOptimization. AutomaticOptimization required for VPP monitoring';
            }
            break;
          case UNKNOWN_ACTIVITY_STATUS || UNKNOWN_SITE_DISPATCH_STATUS:
            desc = 'SiteDispatchStatus is unknown and vpp-monitor has no information to use for monitoring purposes ';
            break;
        }
      }

    }

    return desc;
  }

  getTooltipStatusTitle(element): string {
    if (this.dispatchStatus && this.dispatchStatus.siteDispatchStatuses) {
      for (const siteDispatchStatus of this.dispatchStatus.siteDispatchStatuses) {
        if (siteDispatchStatus && (element.id == siteDispatchStatus.siteId)) {
          return siteDispatchStatus.statusDetail;
        }
      }
      }

    const siteDispatchStatus = this.getSiteDispatchStats(element);
    if (siteDispatchStatus) {
      return siteDispatchStatus.statusDetail;
    }

    return 'N/A';
  }

  getSiteDispatchStats(element): SiteDispatchStats | null {
    if (this.dispatchStatus && this.dispatchStatus.siteDispatchStatuses) {
      for (const siteDispatchStatus of this.dispatchStatus.siteDispatchStatuses) {
        if (element.id == siteDispatchStatus.siteId) {
          return siteDispatchStatus;
        }
      }
    }

    return null;
  }

  getStatusTooltipText(element): string {
    let title = this.getTooltipStatusTitle(element);
    let desc = this.getTooltipDesc(element);
    return`
      ${title}
      ${desc}
    `;
  }

  private getStatusAndGenerationState(siteDispatchStatus: SiteDispatchStats) {
    if (siteDispatchStatus && (siteDispatchStatus.siteStatus == DISPATCH_ACTIVE && siteDispatchStatus.statusDetail == (CHARGING_NOT_GENERATING || GENERATING_NOT_CHARGING))) {
      return true;
    }

    return (siteDispatchStatus) ? siteDispatchStatus.siteStatus == DISPATCH_PENDING && siteDispatchStatus.statusDetail == (CHARGING_NOT_GENERATING || GENERATING_NOT_CHARGING) : 'Error';
  }
}
